import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LinkIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M21.1 2.7c-2.3-2.3-6-2.3-8.3 0l-1.7 1.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l1.7-1.7c1.5-1.5 4-1.5 5.5 0 .8.7 1.2 1.7 1.2 2.8 0 1.1-.4 2.1-1.1 2.9l-3 3c-.1.1-.2.2-.2.3-.1 0-.1.1-.2.1-1.7 1.3-4.2 1-5.6-.8-.3-.4-1-.5-1.4-.2-.4.3-.5 1-.2 1.4 1.2 1.6 3 2.4 4.8 2.4 1.2 0 2.5-.4 3.5-1.2.3-.2.6-.4.8-.7l2.9-2.9c1.1-1.2 1.7-2.7 1.7-4.3 0-1.6-.7-3.1-1.8-4.2zm-9.6 15.5l-1.7 1.7c-1.5 1.5-4 1.5-5.5 0-.8-.7-1.2-1.7-1.2-2.8 0-1.1.4-2.1 1.1-2.9l3-3c.1-.1.2-.2.2-.3.1 0 .1-.1.2-.1.8-.6 1.9-.9 2.9-.8 1.1.2 2 .7 2.7 1.6.3.4 1 .5 1.4.2.4-.3.5-1 .2-1.4a5.9 5.9 0 00-4-2.3c-1.5-.3-3.1.1-4.3 1.1-.3.1-.6.4-.8.7l-2.9 2.9c-1.1 1.2-1.7 2.7-1.7 4.3 0 1.6.7 3.1 1.8 4.2S5.5 23 7 23c1.6 0 3-.6 4.2-1.7l1.7-1.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
LinkIcon.isCarinaIcon = true;
export default LinkIcon;
